module.exports = __webpack_public_path__ + "static/media/user-injured.4a9c1a28.svg";